import { render, staticRenderFns } from "./ResultsCardViewTest.vue?vue&type=template&id=57678883&scoped=true"
import script from "./ResultsCardViewTest.vue?vue&type=script&lang=js"
export * from "./ResultsCardViewTest.vue?vue&type=script&lang=js"
import style0 from "./ResultsCardViewTest.vue?vue&type=style&index=0&id=57678883&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57678883",
  null
  
)

export default component.exports